module.exports = __webpack_public_path__ + "img/trade.49af72b2.png";